routing.$inject = ['$locationProvider', '$urlRouterProvider', '$stateProvider', '$httpProvider'];

export default function routing($locationProvider, $urlRouterProvider, $stateProvider, $httpProvider) {

    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix("!");

    $urlRouterProvider.otherwise('/');

    //
    // Serials2
    //

    $stateProvider.state('serials2', {
        url: '/serials2',
        views: {
            header: 'navigation',
            body: 'serials2'
        },
        ncyBreadcrumb: { label: __('Serials')}
    });

    $stateProvider.state('serials2.titles', {
        url: '/:startWith',
        views: {
            header: 'navigation',
            body: 'serials2Detail'
        },
        params: {
            start: "",
            pos: 1
        }, 
        resolve: {
            startWith: ['$transition$', function($transition$) {
                return $transition$.params().startWith;
            }],
            pos: ['$transition$', function($transition$) {
                return $transition$.params().pos;
            }]
 
        },
        ncyBreadcrumb: { label: __('Список журналов')}
    });

    $stateProvider.state('serials2.titles.years', {
        url: '/:title',
        views: {
            header: 'navigation',
            body: 'serials2TitleDetail'
        },
        resolve: {
            title: ['$transition$', function($transition$) {
                return $transition$.params().title;
            }],
        },
        ncyBreadcrumb: { label: __('Годы издания')}
    });

    $stateProvider.state('serials2.titles.years.docs', {
        url: '/:year',
        views: {
            header: 'navigation',
            body: 'serials2YearDetail'
        },
        resolve: {
            year: ['$transition$', function($transition$) {
                return $transition$.params().year;
            }],
        },
        ncyBreadcrumb: { label: __('Volumes, Issues')}
    });

    $stateProvider.state('serials2.titles.years.docs.doc', {
        url: '/:doc',
        views: {
            header: 'navigation',
            'body@^.^': 'serials2DocDetail'
        },
        resolve: {
            doc: ['$transition$', function($transition$) {
                return $transition$.params().doc;
            }],
        },
        ncyBreadcrumb: { label: __('Document')}
    });

    $stateProvider
        .state('home', {
            url: '/',
            views: {
                header: 'navigation',
                body: 'home'
            },
            ncyBreadcrumb: { skip: true}
        })
        .state('catalogue', {
            url: '/catalogue',
            views: {
                header: 'navigation',
                body: 'catalogue'
            },
            ncyBreadcrumb: { label: __('Catalogue')}
        })
        .state('advanced', {
            url: '/catalogue/advanced',
            views: {
                header: 'navigation',
                body: 'catalogueAdvanced'
            },
            ncyBreadcrumb: { label: __('Advanced search'), parent: 'catalogue'}
        })
        .state('document', {
            url: '/document/:catalogid/{docid:.*}',
            views: {
                header: 'navigation',
                body: 'document'
            },
            resolve: {
                catalogid: ['$transition$', function($transition$) {
                    return $transition$.params().catalogid;
                }],
                docid: ['$transition$', function($transition$) {
                    return $transition$.params().docid;
                }]
            },
            ncyBreadcrumb: { label: __('Document'), parent: 'catalogue'}
        })
        .state('renewalorders', {
            url: '/renewalorders',
            views: {
                header: 'navigation',
                body: 'renewalordersList'
            },
            ncyBreadcrumb: { label: __('АРМ Заявки на продление')}
        })
        .state('kb', {
            url: '/kb',
            views: {
                header: 'navigation',
                body: 'kb'
            },
            ncyBreadcrumb: { label: __('Knowledge base')}
        })
        .state('kbAdvanced', {
            url: '/kbAdvanced',
            views: {
                header: 'navigation',
                body: 'kbAdvanced'
            },
            ncyBreadcrumb: { label: __('Advanced search'), parent: 'kb'}
        })
        .state('kbDocument', {
            url: '/kb/document/:catalogid/{docid:.*}',
            views: {
                header: 'navigation',
                body: 'kbDocument'
            },
            resolve: {
                catalogid: ['$transition$', function($transition$) {
                    return $transition$.params().catalogid;
                }],
                docid: ['$transition$', function($transition$) {
                    return $transition$.params().docid;
                }]
            },
            ncyBreadcrumb: { label: __('Document'), parent: 'kb'}
        })
        .state('kbAdmin', {
            url: '/kbAdmin',
            views: {
                header: 'navigation',
                body: 'kbAdmin'
            },
            ncyBreadcrumb: { label: __('АРМ База знаний')}
        })
        .state('kbAdminCatalog', {
            url: '/kbAdmin/catalog/:id',
            views: {
                header: 'navigation',
                body: 'kbAdminCatalog'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { parent: 'kbAdmin', label: __('Catalog')}
        })
        .state('kbAdminDatabase', {
            url: '/kbAdmin/catalog/:id/database/:id2',
            views: {
                header: 'navigation',
                body: 'kbAdminDatabase'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }],
                id2: ['$transition$', function($transition$) {
                    return $transition$.params().id2;
                }]
            },
            ncyBreadcrumb: { parent: 'kbAdminCatalog', label: __('Database')}
        })
        .state('serials', {
            url: '/serialsSimple',
            views: {
                header: 'navigation',
                body: 'serialsSimple'
            },
            ncyBreadcrumb: { label: __('Serials')}
        })
        .state('serialsBrowsing', {
            url: '/serials/browsing/{start:.*}',
            views: {
                header: 'navigation',
                body: 'serialsBrowsing'
            },
            params: {
                start: "",
                pos: 1
            }, 
            resolve: {
                start: ['$transition$', function($transition$) {
                    return $transition$.params().start;
                }],
                pos: ['$transition$', function($transition$) {
                    return $transition$.params().pos;
                }]
            },
            ncyBreadcrumb: { label: __('Список журналов'), parent: 'serials' }
        })
        .state('serialsAdvanced', {
            url: '/serialsAdvanced',
            views: {
                header: 'navigation',
                body: 'serialsAdvanced'
            },
            ncyBreadcrumb: { label: __('Advanced search'), parent: 'serials'}
        })
        .state('serialsSearch', {
            url: '/serials/search/{title:.*}',
            views: {
                header: 'navigation',
                body: 'serialsSearch'
            },
            resolve: {
                title: ['$transition$', function($transition$) {
                    return $transition$.params().title;
                }]
            },
            ncyBreadcrumb: {label: __('Результаты поиска'), parent: 'serialsBrowsing'}
        })
        .state('serialsDocument', {
            url: '/serials/document/{id:.*}',
            views: {
                header: 'navigation',
                body: 'serialsDocument'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Document'), parent: 'serials'}
        })
        .state('serialsRelatedInstances', {
            url: '/serails/document/relatedInstances/{id:.*}',
            views: {
                header: 'navigation',
                body: 'serialsRelatedInstances'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Volumes / Issues'), parent: 'serialsDocument'}
        })
        .state('ec', {
            url: '/ec',
            views: {
                header: 'navigation',
                body: 'ec'
            },
            ncyBreadcrumb: { label: __('eHoldings')}
        })
        .state('ecAdvanced', {
            url: '/ecAdvanced',
            views: {
                header: 'navigation',
                body: 'ecAdvanced'
            },
            ncyBreadcrumb: { label: __('Advanced search'), parent: 'ec'}
        })
        .state('ecList', {
            url: '/ecList',
            views: {
                header: 'navigation',
                body: 'ecList'
            },
            ncyBreadcrumb: { label: __('eHoldings collections list'), parent: 'ec'}
        })
        .state('ecRelatedInstances', {
            url: '/ec/document/relatedInstances/{id:.*}',
            views: {
                header: 'navigation',
                body: 'ecRelatedInstances'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Related instances'), parent: 'ecList'}
        })
        .state('names', { // names
            url: '/namesSimple',
            views: {
                header: 'navigation',
                body: 'namesSimple'
            },
            ncyBreadcrumb: { label: __('Names')}
        })
        .state('namesBrowsing', {
            url: '/names/browsing/{start:.*}',
            views: {
                header: 'navigation',
                body: 'namesBrowsing'
            },
            params: {
                start: "",
                pos: 1
            }, 
            resolve: {
                start: ['$transition$', function($transition$) {
                    return $transition$.params().start;
                }],
                pos: ['$transition$', function($transition$) {
                    return $transition$.params().pos;
                }]
            },
            ncyBreadcrumb: { label: __('Names list'), parent: 'names'}
        })
        .state('namesAdvanced', {
            url: '/namesAdvanced',
            views: {
                header: 'navigation',
                body: 'namesAdvanced'
            },
            ncyBreadcrumb: { label: __('Advanced search'), parent: 'names'}
        })
        .state('namesSearch', {
            url: '/names/search/{name:.*}',
            views: {
                header: 'navigation',
                body: 'namesSearch'
            },
            resolve: {
                name: ['$transition$', function($transition$) {
                    return $transition$.params().name;
                }]
            },
            ncyBreadcrumb: { label: __('Результаты поиска'), parent: 'namesBrowsing'}
        })
        .state('namesDocument', {
            url: '/names/document/{id:.*}',
            views: {
                header: 'navigation',
                body: 'namesDocument'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Авторитетная запись'), parent: 'names'}
        })
        .state('namesBibliography', {
            url: '/names/document/bibliography/{id:.*}',
            views: {
                header: 'navigation',
                body: 'namesBibliography'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Bibliography'), parent: 'namesDocument'}
        })
        .state('namesPersonality', {
            url: '/names/document/personality/{id:.*}',
            views: {
                header: 'navigation',
                body: 'namesPersonality'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Personality'), parent: 'namesDocument'}
        })
        .state('orgs', { // orgs
            url: '/orgsSimple',
            views: {
                header: 'navigation',
                body: 'orgsSimple'
            },
            ncyBreadcrumb: { label: __('Organizations')}
        })
        .state('orgsBrowsing', {
            url: '/orgs/browsing/{start:.*}',
            views: {
                header: 'navigation',
                body: 'orgsBrowsing'
            },
            params: {
                start: "",
                pos: 1
            }, 
            resolve: {
                start: ['$transition$', function($transition$) {
                    return $transition$.params().start;
                }],
                pos: ['$transition$', function($transition$) {
                    return $transition$.params().pos;
                }]
            },
            ncyBreadcrumb: { label: __('Organizations list'), parent: 'orgs'}
        })
        .state('orgsAdvanced', {
            url: '/orgsAdvanced',
            views: {
                header: 'navigation',
                body: 'orgsAdvanced'
            },
            ncyBreadcrumb: { label: __('Advanced search'), parent: 'orgs'}
        })
        .state('orgsSearch', {
            url: '/orgs/search/{name:.*}',
            views: {
                header: 'navigation',
                body: 'orgsSearch'
            },
            resolve: {
                name: ['$transition$', function($transition$) {
                    return $transition$.params().name;
                }]
            },
            ncyBreadcrumb: { label: __('Результаты поиска'), parent: 'orgsBrowsing'}
        })
        .state('orgsDocument', {
            url: '/orgs/document/{id:.*}',
            views: {
                header: 'navigation',
                body: 'orgsDocument'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Авторитетная запись'), parent: 'orgs'}
        })
        .state('orgsBibliography', {
            url: '/orgs/document/bibliography/{id:.*}',
            views: {
                header: 'navigation',
                body: 'orgsBibliography'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Bibliography'), parent: 'orgsDocument'}
        })
        .state('orgsPersonality', {
            url: '/orgs/document/personality/{id:.*}',
            views: {
                header: 'navigation',
                body: 'orgsPersonality'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Personality'), parent: 'orgsDocument'}
        })
        .state('subj', { // subj
            url: '/subjSimple',
            views: {
                header: 'navigation',
                body: 'subjSimple'
            },
            ncyBreadcrumb: { label: __('Subject headings')}
        })
        .state('subjBrowsing', {
            url: '/subj/browsing/{start:.*}',
            views: {
                header: 'navigation',
                body: 'subjBrowsing'
            },
            params: {
                start: "",
                pos: 1
            }, 
            resolve: {
                start: ['$transition$', function($transition$) {
                    return $transition$.params().start;
                }],
                pos: ['$transition$', function($transition$) {
                    return $transition$.params().pos;
                }]
            },
            ncyBreadcrumb: { label: __('Subject headings list'), parent: 'subj'}
        })
        .state('subjAdvanced', {
            url: '/subjAdvanced',
            views: {
                header: 'navigation',
                body: 'subjAdvanced'
            },
            ncyBreadcrumb: { label: __('Advanced search'), parent: 'subj'}
        })
        .state('subjSearch', {
            url: '/subj/search/{name:.*}',
            views: {
                header: 'navigation',
                body: 'subjSearch'
            },
            resolve: {
                name: ['$transition$', function($transition$) {
                    return $transition$.params().name;
                }]
            },
            ncyBreadcrumb: { label: __('Результаты поиска'), parent: 'subjBrowsing'}
        })
        .state('subjDocument', {
            url: '/subj/document/{id:.*}',
            views: {
                header: 'navigation',
                body: 'subjDocument'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Авторитетная запись'), parent: 'subj'}
        })
        .state('subjBibliography', {
            url: '/subj/document/bibliography/{id:.*}',
            views: {
                header: 'navigation',
                body: 'subjBibliography'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Bibliography'), parent: 'subjDocument'}
        })
        .state('subjPersonality', {
            url: '/subj/document/personality/{id:.*}',
            views: {
                header: 'navigation',
                body: 'subjPersonality'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Personality'), parent: 'subjDocument'}
        })
        .state('subjLinkedDocuments', {
            url: '/subj/document/linkedDocuments/{id:.*}',
            views: {
                header: 'navigation',
                body: 'subjLinkedDocuments'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Связанные документы'), parent: 'subjDocument'}
        })
        .state('ap', { // ap
            url: '/apSimple',
            views: {
                header: 'navigation',
                body: 'apSimple'
            },
            ncyBreadcrumb: { label: __('TPU scientists works') }
        })
        .state('apBrowsing', {
            url: '/ap/browsing/{start:.*}',
            views: {
                header: 'navigation',
                body: 'apBrowsing'
            },
            params: {
                start: "",
                pos: 1
            }, 
            resolve: {
                start: ['$transition$', function($transition$) {
                    return $transition$.params().start;
                }],
                pos: ['$transition$', function($transition$) {
                    return $transition$.params().pos;
                }]
            },
            ncyBreadcrumb: { label: __('Names list'), parent: 'ap'}
        })
        .state('apAdvanced', {
            url: '/apAdvanced',
            views: {
                header: 'navigation',
                body: 'apAdvanced'
            },
            ncyBreadcrumb: { label: __('Advanced search'), parent: 'ap'}
        })
        .state('apSearch', {
            url: '/ap/search/{name:.*}',
            views: {
                header: 'navigation',
                body: 'apSearch'
            },
            resolve: {
                name: ['$transition$', function($transition$) {
                    return $transition$.params().name;
                }]
            },
            ncyBreadcrumb: { label: __('Результаты поиска'), parent: 'apBrowsing'}
        })
        .state('apDocument', {
            url: '/ap/document/{id:.*}',
            views: {
                header: 'navigation',
                body: 'apDocument'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Авторитетная запись'), parent: 'ap'}
        })
        .state('apBibliography', {
            url: '/ap/document/bibliography/{id:.*}',
            views: {
                header: 'navigation',
                body: 'apBibliography'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Bibliography'), parent: 'apDocument'}
        })
        .state('apPersonality', {
            url: '/ap/document/personality/{id:.*}',
            views: {
                header: 'navigation',
                body: 'apPersonality'
            },
            resolve: {
                id: ['$transition$', function($transition$) {
                    return $transition$.params().id;
                }]
            },
            ncyBreadcrumb: { label: __('Personality'), parent: 'apDocument'}
        })
        .state('help', {
            url: '/help',
            views: {
                header: 'navigation',
                body: 'help'
            },
            ncyBreadcrumb: { skip: true }
        })
        .state('login', {
            url: '/login',
            views: {
                header: 'navigation',
                body: 'login'
            },
            ncyBreadcrumb: { skip: true }

        })
        .state('userlinking', {
            url: '/userlinking',
            views: {
                header: 'navigation',
                body: 'userlinking'
            },
            ncyBreadcrumb: {skip: true}
        })
        .state('activeLoans', {
            url: '/activeLoans',
            views: {
                header: 'navigation',
                body: 'activeLoans'
            },
            ncyBreadcrumb: { skip: true }
        })
        .state('requests', {
            url: '/requests',
            views: {
                header: 'navigation',
                body: 'requests'
            },
            ncyBreadcrumb: { skip: true }
        })
        .state('closedLoans', {
            url: '/closedLoans',
            views: {
                header: 'navigation',
                body: 'closedLoans'
            },
            ncyBreadcrumb: { skip: true }
        })
        .state('favorities', {
            url: '/favorities',
            views: {
                header: 'navigation',
                body: 'favoritiesList'
            },
            ncyBreadcrumb: { skip: true }
        })
        .state('basket', {
            url: '/basket',
            views: {
                header: 'navigation',
                body: 'basketList'
            },
            ncyBreadcrumb: { skip: true }
        });
}
